import { createContext } from 'react';
import { CompoundFilterContextProps } from './CompoundFilter.types';

export const CompoundFilterContext = createContext<CompoundFilterContextProps>({
  state: [],
  dispatch: () => {},
});
